import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const ArrowDownIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '70', viewBox = '0 0 70 70' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <rect width='70' height='70' rx='35' fill={fill} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.0004 19.6875C35.2905 19.6875 35.5687 19.8027 35.7738 20.0079C35.9789 20.213 36.0942 20.4912 36.0942 20.7812V46.5784L42.976 39.6944C43.1814 39.489 43.46 39.3736 43.7504 39.3736C44.0409 39.3736 44.3194 39.489 44.5248 39.6944C44.7302 39.8998 44.8455 40.1783 44.8455 40.4688C44.8455 40.7592 44.7302 41.0377 44.5248 41.2431L35.7748 49.9931C35.6732 50.095 35.5525 50.1758 35.4196 50.2309C35.2867 50.2861 35.1443 50.3145 35.0004 50.3145C34.8565 50.3145 34.7141 50.2861 34.5812 50.2309C34.4483 50.1758 34.3276 50.095 34.226 49.9931L25.476 41.2431C25.2707 41.0377 25.1553 40.7592 25.1553 40.4688C25.1553 40.1783 25.2707 39.8998 25.476 39.6944C25.6814 39.489 25.96 39.3736 26.2504 39.3736C26.5409 39.3736 26.8194 39.489 27.0248 39.6944L33.9067 46.5784V20.7812C33.9067 20.4912 34.0219 20.213 34.227 20.0079C34.4321 19.8027 34.7103 19.6875 35.0004 19.6875Z'
        fill='white'
      />
    </svg>
  )
);
ArrowDownIcon.displayName = 'ArrowDownIcon';
export default ArrowDownIcon;
